<template>
  <section class="bg-[--white2] flex flex-col w-full items-center">
    <div
      class="flex flex-col gap-[26px] w-full xl:w-[1280px] py-[24px] px-[50px] lg:px-[100px] xl:px-0 items-center xl:pb-[86px] lg:gap-[32px]">

      <div class="section-header-container">
        <h4 class="section-header-1">Comentários VIPs</h4>
        <h3 class="section-header-2">
          Depoimentos de clientes
        </h3>
      </div>

      <ul id="testimonials" class="flex flex-row w-full !gap-[16px] items-center  xl:hidden">
        <li v-for="(card, index) in cards" :key="index" class="">
          <CardComponent :card="card" />
        </li>
      </ul>

      <ul class=" hidden xl:flex gap-[16px] items-center">
        <li>
          <CardComponent :card="cards[0]" class="!h-[280px] !py-[30px] !min-w-[402px] justify-center" />
        </li>
        <li>
          <CardComponent :card="cards[1]" class="h-[322px] !min-w-[442px] justify-center" />
        </li>
        <li>
          <CardComponent :card="cards[2]" class="!h-[280px] !py-[30px] !min-w-[402px] justify-center" />
        </li>
      </ul>

      <LinkButton customClass="!py-[12.5px] !px-[25px] !w-full !text-[20px] lg:!w-auto" :url="whatsappUrl"
        label="Receber Atendimento Vip" />
    </div>
  </section>
</template>
<script>
import CardComponent from '@/components/CardComponent.vue'
import LinkButton from "../components/LinkButton.vue";
import { useWhatsappUrl } from "@/composables/useWhatsappUrl";

export default {
  name: "TestimonialsSection",
  components: {
    CardComponent,
    LinkButton,
  },
  setup() {
    const { whatsappUrl } = useWhatsappUrl('Olá, gostaria de simular minha antecipação do FGTS.')
    return { whatsappUrl }
  },
  data() {
    return {
      cards: [
        {
          avatarSrc: '/img/avatars/avatar5.webp',
          title: "Tiago Santos",
          text: "Não tenho que reclamar. Sempre fui muito bem atendido. Os atendentes são educados graças a Deus. Por isso vou recomendar. Continue assim autênticos e verdadeiro a prosperidade depende disso",
        },
        {
          avatarSrc: '/img/avatars/avatar6.webp',
          title: "Stephany Helen",
          text: "Vocês são extremamente ágeis com as solicitações, resolvi tudo em pouco tempo. Gostei bastante do atendimento. A equipe está de parabéns!!",
        },
        {
          avatarSrc: '/img/avatars/avatar7.webp',
          title: "Ném Rodrigues",
          text: "Fui atendido pelo Erick Farias Guedes, um atendimento humanizado e muito satisfatório, vocês estão de parabéns, e destaco se todos os funcionários aí forem que nem ele, nunca lhes faltarão clientes. Excelente pessoal, excelente profissional 👏🏽👏🏽👏🏽👏🏽",
        },
      ],
    };
  },
  mounted() {
    // eslint-disable-next-line no-undef
    $("#testimonials").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: false,
      infinite: false,
      dots: false,
      arrows: false,
      autoplay: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  },
};
</script>
